



















































import Vue from 'vue'
import Icon from '@/components/globals/Icon.vue'
import { logout } from '@/core/Auth'
import { StoreAuthLogout } from '@/store/modules/auth/types'

export default Vue.extend({
  components: {
    Icon,
  },
  props: {
    hideSpSearch: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isAboutMenuOpen: false,
    }
  },
  computed: {
    isLogin(): boolean {
      return this.$store.getters['auth/isLogin']
    },
    user(): { name: string } {
      return this.$store.getters['auth/user']
    },
    point(): number {
      return this.$store.getters['auth/point']
    },
  },
  methods: {
    showAboutMenu(): void {
      this.isAboutMenuOpen = true
    },
    hideAboutMenu(): void {
      this.isAboutMenuOpen = false
    },
    async logout() {
      await logout()
      // ステータスコードでOKならばLoginに戻す
      this.$store.commit(new StoreAuthLogout())
      this.$router.push(`/`)
    },
  },
})
